import { render, staticRenderFns } from "./HospitalAnnouncementList.vue?vue&type=template&id=cfb275de"
import script from "./HospitalAnnouncementList.vue?vue&type=script&lang=ts"
export * from "./HospitalAnnouncementList.vue?vue&type=script&lang=ts"
import style0 from "./HospitalAnnouncementList.vue?vue&type=style&index=0&id=cfb275de&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports